import _ from "lodash";

/**
 * 인증 관련 Vuex store
 */
 export default {
  namespaced: true,
  state: {
    authorization: {
      // 인증 정보
      // accessToken: null,
      // avatarUrl : null,
      // deptId: null,
      // expiresIn: null,
      // features: [],
      // localeCode: null,
      // loginId: null,
      // passwordChangedAt: null,
      // refreshToken: null,
      // tokenType: null,
      // userNo: null
      // userName: null
      // isChangedInitPwd: false,
      // userRoles: null,
      features: [],
    },
    authPolicy: {
      // 어플리케이션 기본정보
      init: {
        // 초기화 비밀번호 필수 변경여부
        enforcePasswordChange: null,
      },
      // 변경주기가 지난 비밀번호 변경 정책
      expiredPolicy: {
        // usable: true,
        // passwordExpiresIn: "90",
        // enforcePasswordChange: null,
      },
    },
    isAlertPrevLoginInfo: false,
    initLoginForm: false, // 로그인폼 init 필요 여부
  },
  mutations: {
    /**
     * 인증 값 설정 mutation
     * @param {*} state
     * @param {*} authorization
     */
    SET_AUTHORIZATION(state, authorization) {
      state.authorization = authorization;
      if (null == authorization) {
        localStorage.removeItem("rdx");
      }
    },
    /**
     * 초기화 비밀번호 변경 필수 여부 저장
     */
    SET_ENFORCE_INIT_PASSWORD_CHANGE(state, policy) {
      state.authPolicy.init.enforcePasswordChange = policy;
    },
    /**
     * 변경주기가 지난 비밀번호 변경 정책 저장
     */
    SET_EXPIRED_POLICY(state, policy) {
      state.authPolicy.expiredPolicy = policy;
    },
    /**
     * 프로필 갱신
     */
    SET_PROFILE_INFO(state, profileInfo) {
      state.authorization.avatarUrl = profileInfo.avatarUrl;
      state.authorization.deptId = profileInfo.deptId;
      state.authorization.userName = profileInfo.userName;
      localStorage.setItem("rdx", state.authorization);
    },
    SET_ALERT_PREV_LOGIN_INFO(state, isOpen) {
      state.isAlertPrevLoginInfo = isOpen;
    },
    INIT_LOGIN_FORM(state, init) {
      state.initLoginForm = init;
    },
    RESET_AUTHORIZATION_EXCEPT_FEATURES(state) {
      const _prevLoginId = JSON.parse(JSON.stringify(state.authorization.loginId || ""));
      sessionStorage.setItem("prevLoginId", _prevLoginId);
      state.authorization = { features: state.authorization.features };
      localStorage.removeItem("rdx");
    }
  },
  getters: {
    /**
     * 인증 정보 취득 getter
     */
    getAuthorization: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization;
      } else {
        return null;
      }
    },
    getPrevAccessLog: (state) => {
      if (_.get(state.authorization, "prevAccessLog")) {
        return state.authorization.prevAccessLog;
      } else {
        return null;
      }
    },
    // isReissuing: (state) => {
    //   return state.isReissuing;
    // },
    /**
     * 토큰 정보 취득 getter
     */
    getAccessToken: (state) => {
      let accessToken = null;
      if (_.get(state.authorization, "accessToken")) {
        accessToken = `${state.authorization.tokenType} ${state.authorization.accessToken}`;
      }
      return accessToken;
    },
    /**
     * 리프래시 토큰 취득 getter
     */
    getRefreshToken: (state) => {
      let refreshToken = null;
      if (_.get(state.authorization, "accessToken")) {
        refreshToken = `${state.authorization.tokenType} ${state.authorization.refreshToken}`;
      }
      return refreshToken;
    },
    getRefreshTokenWithoutPrefix: (state) => {
      let refreshToken = null;
      if (_.get(state.authorization, "accessToken")) {
        refreshToken = `${state.authorization.refreshToken}`;
      }
      return refreshToken;
    },
    /**
    * 토큰 타입 취득 getter
    */
    getTokenType: (state) => {
      if (_.get(state.authorization, "tokenType")) {
        return state.authorization.tokenType;
      } else {
        return null;
      }
    },
    /**
    * 사용처 코드 취득 getter
    */
    getUseplcCode: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.useplcCode;
      } else {
        return null;
      }
    },

    /**
     * 사용자번호 취득 getter
     */
    getUserId: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.userId;
      } else {
        return null;
      }
    },
    getRoles: (state) => {
      return _.get(state.authorization, "features");
    },
    getUserName: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.userName;
      } else {
        return null;
      }
    },
    getIsChangedInitPwd: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.isChangedInitPwd;
      } else {
        return null;
      }
    },
    getPasswordChagedAt: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.passwordChangedAt;
      } else {
        return null;
      }
    },
    getUserRoles: (state) => {
      if (_.get(state.authorization, "accessToken")) {
        return state.authorization.userRoles;
      } else {
        return null;
      }
    },
    getEnforceInitPasswordChange: (state) => {
      return state.authPolicy.init.enforcePasswordChange;
    },
    getExpiredPolicy: (state) => {
      return state.authPolicy.expiredPolicy;
    },
    getEnforceExpiredPasswordChange: (state) => {
      return state.authPolicy.expiredPolicy.enforcePasswordChange;
    },
    getIsAlertPrevLoginInfo: (state) => {
      return state.isAlertPrevLoginInfo;
    },
    getInitLoginForm: (state) => {
      return state.initLoginForm;
    }
  },
  actions: {
    /**
     * 인증값 설정 action
     * @param {*} param0
     * @param {*} authorization
     */
    setAuthorization({ commit }, authorization) {
      commit("SET_AUTHORIZATION", authorization);
    },
    /**
     * 인증값 초기화
     * @param {*} param0
     */
    initAuthorization({ commit }) {
      commit("SET_AUTHORIZATION", null);
    },
    /**
     * 인증 정책 설정 action
     */
    setEnforceInitPasswordChange({ commit }, policy) {
      commit("SET_ENFORCE_INIT_PASSWORD_CHANGE", policy);
    },
    setExpiredPolicy({ commit }, policy) {
      commit("SET_EXPIRED_POLICY", policy);
    },
    /**
     * 프로필 갱신 action
     * @param {*} param0
     * @param {*} profileInfo
     */
    setProfileInfo({ commit }, profileInfo) {
      commit("SET_PROFILE_INFO", profileInfo);
    },
    setIsAlertPrevLoginInfo({ commit }, isOpen) {
      commit("SET_ALERT_PREV_LOGIN_INFO", isOpen);
    },
    initLoginForm({ commit }, init) {
      commit("INIT_LOGIN_FORM", init);
    },
    resetAuthorizationExceptFeatures({ commit }) {
      commit("RESET_AUTHORIZATION_EXCEPT_FEATURES");
    }
  },
};
